import axios from "@/utils/request.js";
// 分页获取平台号列表
export const subscriptionManagerPage = (params) => axios.get('/api/web-operate/platform/manager/page', {
    params
})
// 分页获取平台号分类列表
export const subscriptionPage = (params) => axios.get('/api/web-operate/platform/classify/page', {
    params
})
//问政详情
export const politicsDetail = (params) => axios.get('api/web-operate/platform/politics/detail', {
    params
})
//文件上传到隐藏库
export const upFile = (data) => axios.post('api/web-manager/file/manager/upload/hide',
    data
)
//分页获取网络问政单列表
export const politicsPage = (params) => axios.get('/api/web-operate/platform/politics/page', {
    params
})
//添加问政单

export const addPolitics = (data) => axios.post('api/web-operate/platform/politics/add',
    data
)
//获取租户相关配置组
export const getTenantGroup = (params) => axios.get('/api/web-basic/configuration/manager/tenant/json', {
    params
})
//获取app最新版本
export const getNewAppVersion = (params) => axios.get('/api/web-terminal/project/version/app/newest', {
    params
})

export const getdSignature = (data) => axios.post('/api/web-conf/tripart/auth/signature',
    data
)
